<payee-popup>
  <ng-template #payeePopupTitleTemplate>
    <payee-icon
      name="stop-sign"
      class="title-icon"
      height="73px"
      width="auto"
    ></payee-icon>
    <h1>{{ "WORKFLOW_DIALOGS.CLOSE_CASE.TITLE" | translate }}</h1>
  </ng-template>

  <ng-template #payeePopupDescriptionTemplate>
    <div class="description">
      {{ "WORKFLOW_DIALOGS.CLOSE_CASE.DESCRIPTION" | translate }}
    </div>
  </ng-template>

  <ng-template #payeePopupSubmitTemplate>
    <button
      payee-button
      color="blue"
      width="max"
      height="normal"
      [disabled]="loading"
      [loading]="loading"
      (click)="submitPaid()"
    >
      <ng-container>
        {{ "WORKFLOW_DIALOGS.CLOSE_CASE.PAID" | translate }}
      </ng-container>
    </button>
    <button
      payee-button
      color="grey-dark"
      width="max"
      height="normal"
      [disabled]="loading"
      [loading]="loading"
      (click)="submitOther()"
    >
      <ng-container>
        {{ "WORKFLOW_DIALOGS.CLOSE_CASE.OTHER_REASON" | translate }}
      </ng-container>
    </button>
  </ng-template>

  <ng-template #payeePopupCancelTemplate>
    <button
      payee-button
      color="white"
      width="max"
      height="normal"
      [isBorderButton]="true"
      (click)="cancel()"
    >
      <ng-container>
        {{ "WORKFLOW_DIALOGS.CLOSE_CASE.CANCEL" | translate }}
      </ng-container>
    </button>
  </ng-template>
</payee-popup>
